import { render, staticRenderFns } from "./Shades.vue?vue&type=template&id=c3d68156&scoped=true&"
import script from "./Shades.vue?vue&type=script&lang=js&"
export * from "./Shades.vue?vue&type=script&lang=js&"
import style0 from "./Shades.vue?vue&type=style&index=0&id=c3d68156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d68156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VFlex,VIcon,VLayout})
